
import { QRPaymentReport } from "../../classes"

const QRPaymentReportModule = {
  namespaced: true,
  state: {
    qrPaymentReports: [],
  },
  mutations: {
    setQRPaymentReports(state, qrPaymentReports) {
      state.qrPaymentReports = qrPaymentReports || []
    },
  },
  actions: {
    getQRPaymentReportBetweenDateByMarket: async ({ commit }, { marketId, startDate, endDate }) => {
      try {
        let result = await QRPaymentReport.getQRPaymentReportBetweenDateByMarket(marketId, startDate, endDate);
        commit('setQRPaymentReports', result || [])
        return result;
      } catch (error) {
        throw error
      }
    },
    getQRPaymentReportBetweenDateByProject: async ({ commit }, { projectId, startDate, endDate }) => {
      try {
        let result = await QRPaymentReport.getQRPaymentReportBetweenDateByProject(projectId, startDate, endDate);
        commit('setQRPaymentReports', result || [])
        return result;
      } catch (error) {
        throw error
      }
    },
  },
  getters: {

  },
};
export default QRPaymentReportModule;
